import _get from 'lodash/get'

export const get_buyer_locations = state => _get(state, 'buyerlocation.buyerlocation')

export default get_buyer_locations
